/**
 * FERP Portal - Dependency List Page (DRR-074: Tabulator DRY Template)
 *
 * DESIGN Phase: Inter-primitive dependency tracking and ordering.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function DependencyListPage() {
  return <TabulatorPrimitiveManager primitiveType="dependency" />;
}

export default DependencyListPage;
